import React from 'react';

const Coursework = () => {
  return (
    
    <div className="skills__content">
        <h3 className="skills__title">Coursework/Others</h3>

        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                <div>
                    <h3 className="skills_name">AI/ML</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                <div>
                    <h3 className="skills_name">Data Structures</h3>
                    <span className="skills__level">Advanced</span>
                </div>
                </div>

                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                <div>
                    <h3 className="skills_name">OOPS Concept</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                <div>
                    <h3 className="skills_name">DBMS</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>
                </div>

                <div className="skills__group">
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                <div>
                    <h3 className="skills_name">Operating System</h3>
                    <span className="skills__level">Advanced</span>
                </div>
                </div>

                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                <div>
                    <h3 className="skills_name">Python</h3>
                    <span className="skills__level">Basic</span>
                </div>
                </div>

                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                <div>
                    <h3 className="skills_name">MS Excel</h3>
                    <span className="skills__level">Basic</span>
                </div>
                </div>

                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                <div>
                    <h3 className="skills_name">Software Engineering</h3>
                    <span className="skills__level">Advanced</span>
                </div>
                </div>
                </div>
        </div>
    </div>
  );
};

export default Coursework;